<template>
  <div id="homePage">
    <div class="index" v-if="status === 1">
      <div class="moon"></div>
      <div class="spot"></div>
      <img class="qrcode" :src="require('@/assets/nbOL/qrcode.png')">
      <a class="order" href="https://m.haimati.cn/#/?f=100">预 约</a>
      <div class="tosign" @click="toSubmit"></div>
    </div>
    <div class="sign-up" v-if="status === 2">
      <div class="signup-header"></div>
      <div class="form">
        <div class="item"><div class="form-head">姓名<span>*</span></div><div class="form-body"><input type="text" v-model="form.name" placeholder="至少2个字"></div></div>
        <div class="item"><div class="form-head">手机号<span>*</span></div><div class="form-body"><input type="text" maxlength="11" v-model="form.phone" placeholder="请填写" @keyup="filterNumber"></div></div>
        <div class="item"><div class="form-head">微信号<span>*</span></div><div class="form-body"><input type="text" v-model="form.wechatAccount" placeholder="请填写"></div></div>
        <div class="item"><div class="form-head">步入职场几年<span>*</span></div><div class="form-body"><input type="text" maxlength="2" v-model="form.jobYear" placeholder="请填写(数字)" @input="filterYear"></div></div>
        <div class="item"><div class="form-head">职业<span>*</span></div><div class="form-body"><input type="text" v-model="form.job" placeholder="请填写"></div></div>
        <div class="item"><div class="form-head">公司<span>*</span></div><div class="form-body"><input type="text" v-model="form.company" placeholder="请填写"></div></div>
        <div class="item">
          <div class="form-head">是否拍过海马体<span>*</span></div>
          <div class="form-body">
            <select name="oldCustomer" id="yOrn" v-model="form.oldCustomer" :class="{changeColor: isSelected}">
              <option value='请选择' selected>请选择</option>
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
          </div>
        </div>
        <div class="upload-wrap">
          <div class="upload-title">上传照片(可选填)</div>
          <label for="imgFile">
            <div v-if="!imageSrc" class="upload-icon">
              <div class="icon"></div>
              <span>请上传近期照片</span>
            </div>
            <img :src="imageSrc" v-else>
          </label>
          <input id="imgFile" type="file" accept="image" style="display: none" @change="uplaodPhoto">
        </div>
      </div>
      <div class="submit" @click="submit">提 交</div>
    </div>
    <div class="success" v-if="status === 3">
      <div class="success-icon"></div>
      <div class="success-qrcode"></div>
      <img :src="require('@/assets/nbOL/success-qrcode.png')" class="success-qrcode">
    </div>
  </div>
</template>
<script>
export default {
  name: 'homePage',
  data () {
    return {
      isIpx: false,
      signUp: true,
      status: 1,
      form: {
        name: '',
        phone: '',
        wechatAccount: '',
        jobYear: '',
        job: '',
        company: '',
        oldCustomer: '请选择',
        imgUrl: ''
      },
      imageSrc: '',
      upyunSign: {}
    }
  },
  computed: {
    isSelected () {
      if (this.form.oldCustomer !== '请选择') {
        return true
      }
      return false
    }
  },
  methods: {
    filterYear () {
      this.form.jobYear = this.form.jobYear.replace(/[^\d]/g, '')
    },
    jumpPage (path) {
      this.$router.push({path: path})
    },
    filterNumber (event) {
      event.target.value = event.target.value.replace(/[^\d]/g, '')
    },
    uplaodPhoto (e) {
      let file = e.target.files[0]
      let reader = new FileReader()
      let formData = new FormData()
      let postUrl = 'http://v0.api.upyun.com/' + this.upyunSign.bucket
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      formData.append('policy', this.upyunSign.policy)
      formData.append('signature', this.upyunSign.signature)
      formData.append('file', file)
      this.$axios.post(postUrl, formData, config).then(res => {
        this.form.imgUrl = res.data.url
      })
      reader.readAsDataURL(file)
      reader.onload = e => {
        this.imageSrc = e.target.result
      }
    },
    toSubmit () {
      this.status = 2
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
    },
    submit () {
      // 报名
      let now = Math.round(new Date() / 1000)
      if (now > 1530892799) {
        this.$toast('活动已结束')
        return false
      }
      let postData = {
        'activity_id': 'QlLH0cKKj6z9SRQSNCxVpktYkD5U9Dpn'
      }
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/add_item'
      let data = JSON.parse(JSON.stringify(this.form))
      for (let i in data) {
        if (!data[i] && i !== 'imgUrl') {
          this.$toast('请填写完整')
          return false
        }
      }
      if (data.oldCustomer === '请选择') {
        this.$toast('请填写完整')
        return false
      }
      if (data.name.length < 2) {
        this.$toast('请输入正确姓名')
        return false
      }
      postData.activity_content = data
      this.$axios.post(postUrl, postData).then(res => {
        if (res.data.success) {
          this.status = 3
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 300)
        }
      }).catch(err => {
        console.log(err)
        this.$toast('每个手机号只能报名一次')
      })
    },
    getUpyunSign () {
      let getUrl = 'http://vote.mantusy.com/index.php/ApplyFaceplan/getUpyunSign'
      this.$axios.post(getUrl).then(res => {
        this.upyunSign = res.data.msg
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getUpyunSign()
  }
}
</script>

<style scoped lang="less">
#homePage {
  font-size: .36rem /* 26/75 */;
  .index {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 170.67rem /* 12800/75 */;
    background-image: url('~@/assets/nbOL/index-bg.jpg');
    margin-top: -.4rem;
    .moon {
      width: 5rem /* 522/75 */;
      height: 5rem /* 522/75 */;
      position: absolute;
      top: 3.5rem;
      left: 2.5rem;
      background-image: url('~@/assets/nbOL/moon.gif');
    }
    .spot {
      width: 1.09rem /* 82/75 */;
      height: .24rem /* 18/75 */;
      align-self: flex-start;
      position: absolute;
      margin-left: .4rem;
      top: 28rem;
      background-image: url('~@/assets/nbOL/spot.gif');
    }
    .qrcode {
      width: 8.61rem /* 646/75 */;
      position: absolute;
      top: 155.2rem;
      left: .7rem;
    }
    .order {
      font-size:  .44rem /* 36/75 */;
      position: absolute;
      top: 165.2rem;
      width: 2rem;
      height: 1rem;
      left: 4rem;
      line-height: 1rem;
      text-decoration: none;
      color: #003865;
      display: inline-block;
      border-radius: .1rem;
      border: 1px solid #003856;
    }
    .tosign {
      background-image: url('~@/assets/nbOL/signup.png');
      width: 100%;
      height: 1.47rem /* 110/75 */;
      box-shadow: 0 0 5px #ccc;
      position: fixed;
      bottom: 0;
    }
  }
  .sign-up {
    background-color: #f1efe8;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    .signup-header {
      width: 8.61rem /* 646/75 */;
      height: 5.84rem /* 438/75 */;
      background-image: url('~@/assets/nbOL/signup-header.png')
    }
    .form {
      width: 8.59rem /* 644/75 */;
      .item {
        width: 100%;
        border: 1px solid #003856;
        margin-top: .3rem;
        height: 1.07rem /* 80/75 */;
        line-height: 1.05rem /* 80/75 */;
        display: flex;
        flex-flow: row nowrap;
        .form-head {
          width: 3rem;
          border-right: 1px solid #003854;
          span {
            color: #E31955;
          }
        }
        .form-body {
          width: 5.52rem;
          input {
            width: 100%;
            height: 1rem;
            background-color: transparent;
            border: none;
            padding: 0 20px;
            text-align: center;
            font-size: .36rem;
            color: #003854;
          }
          select {
            width: 100%;
            height: 1rem;
            border: none;
            background-color: transparent;
            text-indent: 2.07rem;
            font-size: .36rem;
            color: #aaa;
          }
          .changeColor {
            text-indent: 2.47rem;
            color: #003854;
          }
        }
      }
    }
    .upload-wrap {
      .upload-title {
        text-align: left;
        margin: .3rem 0;
      }
      label {
        display: inline-block;
        height: 4.16rem /* 312/75 */;
        width: 100%;
        border: 1px solid #003458;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        .upload-icon {
          margin: 0 auto;
          text-align: center;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: center;
        }
        img {
          max-width: 100%;
          max-height: 4.1rem;
        }
        .icon {
          width: .88rem /* 66/75 */;
          height: .72rem /* 54/75 */;
          background-image: url('~@/assets/nbOL/camera.png')
        }
        span {
          margin-top: .2rem;
          letter-spacing: 1px;
        }
      }
    }
    .submit {
      width: 8.6rem;
      height: 1.17rem /* 88/75 */;
      background-color: #003458;
      color: #fff;
      border-radius: .1rem;
      line-height: 1.17rem;
      font-size: .48rem /* 36/75 */;
      margin-top: 2rem /* 164/75 */;
      margin-bottom: .8rem;
      bottom: 0;
    }
  }
  .success {
    height: 100vh;
    width: 100%;
    background-color: #f1efe8;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .success-icon {
      width: 2.67rem /* 200/75 */;
      height: 3.73rem /* 280/75 */;
      background-image: url('~@/assets/nbOL/success.png')
    }
    .success-qrcode {
      width: 8.56rem /* 642/75 */;
      margin-top: 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nbOL/homePage.vue